module.exports = __webpack_public_path__ + "static/media/4-8.e27d1336.webp";